import { useHistory } from 'react-router';
import { useOverlayContext } from 'seagull';
import IntegrationCard from "../IntegrationCard/IntegrationCard";
import { useStoreActions } from "../../../store/store-context";
import APIKeyModal from "../APIKeyModal/APIKeyModal";
import clientHubLogoUrl from "./client-hub-logo.png";
import { PracticeManagement } from "../../../types/api.model";
import { CardHandler } from "../APIKeyPM/APIKeyPM.utils";
import { routes } from "../../../constants";
import { jsx as _jsx } from "react/jsx-runtime";
const ClientHubCard = _ref => {
  let {
    integration
  } = _ref;
  const history = useHistory();
  const overlayContext = useOverlayContext();
  const {
    api,
    fetchIntegrations
  } = useStoreActions();
  const ui = {
    goToPage: page => history.push(page),
    requestApiKey: apiKeyListener => overlayContext.showModal({
      content: _ref2 => {
        let {
          dismissModal
        } = _ref2;
        return /*#__PURE__*/_jsx(APIKeyModal, {
          pmName: PracticeManagement.ClientHub,
          dismissModal: dismissModal,
          apiKeyListener: apiKeyListener
        });
      }
    }),
    refetchIntegrations: async () => fetchIntegrations()
  };
  const server = {
    saveApiKey: async apiKey => api.clientHub.setAPIKey(apiKey)
  };
  const clientHubCardHandler = new CardHandler(ui, integration, server);
  return /*#__PURE__*/_jsx(IntegrationCard, {
    "data-testid": "client-hub-card",
    title: "Client Hub",
    subTitle: "Seamlessly connect client billing in Anchor to practice management in Client Hub",
    mainAction: /*#__PURE__*/_jsx(IntegrationCard.MainActionButton, {
      "data-testid": "client-hub-card-connect",
      onClick: () => clientHubCardHandler.handleClick(routes.clientHubSetup),
      children: clientHubCardHandler.getActionText()
    }),
    icon: /*#__PURE__*/_jsx(IntegrationCard.LogoImg, {
      alt: "client hub logo",
      src: clientHubLogoUrl
    }),
    disclaimer: "* Requires the Premium plan in Client Hub"
  });
};
export default ClientHubCard;